import type { GeoJsonPolygon } from '../types';

export default function isGeojsonPolygon(geometry: GeoJsonPolygon): boolean {
  return geometry &&
    geometry.type === 'Polygon' &&
    geometry.coordinates &&
    geometry.coordinates[0] &&
    geometry.coordinates[0].length > 2;
}
